import React, { Component } from "react";
import {
  Layout,
  Dropdown,
  Menu,
  Icon,
  Row,
  Col,
  Input,
  Tooltip,
  Pagination,
  Spin,
  Select,
  Popconfirm,
  Button,
} from "antd";
import { Link } from "react-router-dom";
// import Head from "../components/Head";
// import Foote from "../components/Footer";
// import ICP from "../components/ICP";
import default_head from "../../../assets/head_default_img.png";
import "../../../css/search-result.css";
import { api, app } from "../../../app";
import config from "../../../config";

const { Header, Content } = Layout;
const Option = Select.Option;

function NoData(props) {
  return (
    <p className="no_data">
      在<span>{props.search_type_str}</span>中搜索不到与“{" "}
      <span>{props.search_val}</span> ”相关的内容!
    </p>
  );
}

class SearchResult extends Component {
  constructor(props) {
    super(props);
    // const search_type = props.match.params.search_type,
    // search_val = props.match.params.search_val;
    // let search_type_str = "姓名";
    this.state = {
      img:
        config.imgUrl +
        "/Uploads/jiaZheng99krltkerkewrewkrewkrewpkrekrpweewfe.jpg",
      token: "",
      isTrue: false,
      classList: [],
      resultList: [],
      teamList: [],
      team_id: "",
      class_loading: false,
      status: undefined,
      data_loading: false,
      page: 1,
      total: 0,
      search_type_str: "姓名",
      search_type: "searchform_name",
      search_val: "",
      search_val_flag: false,
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  async componentDidMount() {
    this._isMounted = true;
    if (this.props.edit_id) {
      console.log(this.props);
      this.setState({ search_val: "", resultList: [] });
    }
    this.getTokeni();
    await this.getteamList();
    //     // 判断token
    //     // 1. token参数是否存在
    //     // 2. '?token'必须放在传参的第一位
    //     // 3. token后面的值是否存在
    //     // 4. token值是否有效

    //     // 是否显示搜索结果
    //     // 存在token且有效则显示搜索结果
    //     // 存在token且无效则显示假证

    //     let a = window.location.search;
    //     let b = a.indexOf('?token');
    //     // console.log(a);
    //     // console.log(a.indexOf('?token'));
    //     // 1. token参数是否存在
    //     if (b == -1) {
    //         // console.log("假证：不存在token参数");
    //         this.setState({
    //             isTrue: true,
    //             data_loading: false,
    //         });
    //     } else {
    //         let c = a.substr(0, 7);
    //         // 2. '?token='必须放在传参的第一位
    //         if (c == '?token=') {
    //             // 第2步正确，进行第3步
    //             // 3. token后面的值是否存在
    //             let d = a.substr(7);
    //             // this.getTokeni(d);
    //             // 截取url中传递的token，并返回数据库进行查询
    //             // 该token存在且有效则加载搜索页面，否者显示假证页面
    //             if (d.length > 0) {
    //                 // 第3步正确，进行第4步
    //                 // 4. token值是否有效
    //                 // console.log('存在token，返回数据库查询是否有效 ==> '+c);
    //                 // 有效，显示搜索结果
    //                 this.getTokeni(d);

    //             } else {
    //                 // console.log("token参数值为空，假证！");
    //                 this.setState({
    //                     isTrue: true,
    //                     data_loading: false,
    //                 });
    //             }
    //         } else {
    //             // console.log("传参的第一位没有token，假证！");
    //             this.setState({
    //                 isTrue: true,
    //                 data_loading: false,
    //             });
    //         }
    //     }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * 数据集
   * @param search_type
   * @param search_val
   */
  dataSource = (
    page = 1,
    search_type,
    search_val,
    version_id = api.version_id,
    search_method = "valid"
  ) => {
    const _this = this,
      params = {
        search_type,
        search_val,
        page,
        version_id,
        search_method: "valid",
      };
    this.setState({ data_loading: true, page, version_id }, () => {
      console.log(params);
      params.name = params.search_val;
      app.post(api.YjhomeSearch, params).then(({ flag, data, msg, total }) => {
        if (flag === 1) {
          const resultList = [],
            search_type_str = _this.state.search_type_str;
          data.forEach((res) => {
            const obj = {
              name: res.vname,
              no: res.bsrno,
              localpath: res.portrait
                ? config.imgUrl + app.urlEncode(res.portrait)
                : default_head,
              indexno: res.indexno,
              team_id: res.team_id,
              coinAdmin: res.coinAdmin,
              uri: `/player/${res.team_id}/${res.indexno}/?token=${_this.state.token}`,
              indexno_coin: res.indexno,
              kx: null,
            };
            if (res.volunteer_state === "4") {
              obj.kx = "已离队";
            } else if (res.volunteer_state === "5") {
              obj.kx = "已清退";
            }
            resultList.push(obj);
          });

          _this.setState({
            data_loading: false,
            resultList,
            no_data:
              resultList.length > 0
                ? ""
                : NoData({ search_type_str, search_val }),
            total: isNaN(parseInt(total)) ? 0 : parseInt(total),
          });
        } else {
          app.alert(msg, "error");
        }
      });
    });
  };

  // 获取人才库类型
  getClassList = async (e) => {
    let that = this;
    let { flag, data, msg } = await app.post(api.identityClassList, {
      version_id: api.version_id,
    });
    if (flag === 1) {
      this.setState({ classList: data });
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 获取token
   * @returns {Promise<void>}
   */
  getTokeni = async (e) => {
    let that = this;

    let { flag, data, msg } = await app.post(api.getToken);

    if (flag === 1) {
      // if (data.token == e) {
      //     // that.handleLoading();
      that.setState({
        token: data.token,
      });
      // } else {
      //     // console.log("token无效，假证！");
      //     that.setState({
      //         isTrue: true,
      //         data_loading: false,
      //     });
      // }
    } else {
      app.alert(msg, "warn");
    }
  };

  getAdd = async (volunteer_id) => {};

  /**
   * 添加
   * @param id
   */
  handleDelete = async (res) => {
    let { team_id, status } = this.state;
    if (!team_id) {
      app.alert("请选择队伍！", "warn");
      return;
    }
    const params = {
      account: app.getData("account"),
      indexno: app.getData("indexno"),
      indexno_coin: res.indexno_coin,
      coinAdmin: 2,
      class_id: status,
      team_id,
    };
    let { flag, data, msg } = await app.post(api.addCoinAdmin, params);
    if (flag === 1) {
      let { onClose } = this.props;
      onClose(true);
    } else {
      app.alert(msg, "warn");
      // let { onClose } = this.props;
      // onClose(true);
    }
  };

  // 队伍列表
  getteamList = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.getTeamName, params);
    if (flag === 1) {
      this.setData({ teamList: data });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  handleMenuClick = (e) => {
    const search_type_str = e.item.props.children,
      search_type = e.key;
    this.setState({ search_type, search_type_str });
  };

  /**
   * 搜索
   * @returns {boolean}
   */
  handleSearch = async (value) => {
    let { search_val } = this.state;
    if (!value) {
      this.setState({ resultList: [] });
    } else {
      let { flag, data, msg } = await app.post(api.getToken);
      if (flag === 1) {
        const search_val = value;
        const search_type = this.state.search_type,
          search_val_flag = this.state.search_val_flag;
        this.dataSource(1, search_type, search_val);
        if (!search_val) {
          if (search_val_flag === false) {
            this.setState({ search_val_flag: true });
            const timer = setTimeout(() => {
              this.setState({ search_val_flag: false });
              clearTimeout(timer);
            }, 3000);
          }

          return false;
        }
      } else {
        this.setState({
          isTrue: true,
          data_loading: false,
        });
        app.alert(msg, "warn");
      }

      //     this.props.history.replace(`/search-result/${search_type}/${search_val}?token=${data.token}`);
      this.setState({ search_val: value });
      this.state.token = data.token;
      this.setState({
        token: data.token,
        isTrue: false,
        data_loading: false,
      });
    }
    // 在搜索页面点击搜索时也要获取一遍token
    // console.log();
    // this.props.history.replace(`/search-result/${search_type}/${search_val}/?token=${this.state.token}`);
  };

  /**
   * 分页修改
   */
  handlePageChage = (page) => {
    console.log(this.state.search_val);
    this.dataSource(page, this.state.search_type, this.state.search_val);
  };

  render() {
    const class_loading = this.state.class_loading,
      classList = this.state.classList,
      search_type_str = this.state.search_type_str,
      search_val = this.state.search_val,
      data_loading = this.state.data_loading,
      page = this.state.page,
      result_total = this.state.total,
      teamList = this.state.teamList,
      no_data = this.state.no_data,
      resultList = this.state.resultList || [],
      search_val_flag = this.state.search_val_flag,
      load_node = (
        <div className="loading">
          <Spin size="large" />
        </div>
      );
    return (
      <div className="search-result">
        <Layout>
          {/* <Header>
            <Head
              background="#3F89C1"
              height={100}
              history={this.props.history}
            />
          </Header> */}
          <Content>
            {/*<Row className="s_search">*/}
            <Row style={{ width: "40%", margin: "30px auto" }}>
              <Col span={18} style={{ height: "100%" }}>
                <div>
                  <span>核销队伍：</span>
                  <Select
                    defaultValue="请选择队伍"
                    style={{ width: 250 }}
                    onChange={async (value) => {
                      await this.setData({ team_id: value });
                    }}
                  >
                    {teamList.length > 0 &&
                      teamList.map((item, index) => (
                        <Option key={item.team_id} value={item.team_id}>
                          {item.teamname}
                        </Option>
                      ))}
                  </Select>
                </div>
              </Col>
            </Row>
            <Input.Group
              className="s_search"
              compact
              style={{ borderRight: "none" }}
            >
              <Col span={6} style={{ height: "100%" }}>
                <Dropdown
                  overlay={
                    <Menu onClick={this.handleMenuClick}>
                      <Menu.Item key="searchform_name">姓名</Menu.Item>
                      <Menu.Divider />
                      <Menu.Item key="searchform_code">编号</Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                >
                <div
                  type="flex"
                  align="middle"
                  justify="space-around"
                  className="z_s"
                  style={{display:'flex',alignItems:'center',justifyContent:'center'}}
                >
                  <span>{search_type_str}</span>
                  <Icon type="down" />
                </div>
                </Dropdown>
              </Col>
              <Col span={18} style={{ height: "100%" }}>
                {/* <Tooltip placement="bottomLeft" trigger="" visible={search_val_flag}> */}
                <Input.Search
                  size="large"
                  placeholder="请输入搜索内容"
                  onSearch={(value) => this.handleSearch(value)}
                  style={{ height: "100%" }}
                  defaultValue={search_val}
                  enterButton
                />
                {/* </Tooltip> */}
              </Col>
            </Input.Group>
            <div className="result-list">
              {data_loading
                ? load_node
                : resultList.length > 0
                ? resultList.map((res, index) => {
                    return (
                      <Col
                        key={index + 1}
                        className="item"
                        style={{ margin: "20px 0" }}
                      >
                        <Link to={res.uri}>
                          <div></div>
                          <div className="img">
                            <img src={res.localpath} alt="" />
                            {res.kx ? <div className="kx">{res.kx}</div> : null}
                          </div>
                          <p className="name">{res.name}</p>
                          <p className="num">{res.no}</p>
                          <p className="num">{res.bottom_txt}</p>
                        </Link>
                          <Popconfirm
                            placement="bottom"
                            title="确定添加吗"
                            cancelText="取消"
                            okText="确定"
                            onConfirm={() => this.handleDelete(res)}
                          >
                            <Button type="primary">添加</Button>
                          </Popconfirm>
                      </Col>
                    );
                  })
                : no_data}
              {this.state.isTrue ? (
                <img
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginTop: "100px",
                  }}
                  src={this.state.img}
                  alt=""
                />
              ) : (
                ""
              )}
            </div>

            <Row className="page" type="flex" justify="center">
              <Pagination
                hideOnSinglePage
                showTotal={(total) => `总数：${total}`}
                current={page}
                showQuickJumper
                pageSize={20}
                total={result_total}
                onChange={this.handlePageChage}
              />
            </Row>
            {/* <div className="footer-list">
              <Foote />
              <ICP bg="#434343" />
            </div> */}
          </Content>
        </Layout>
      </div>
    );
  }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/routes/grade/Verification/verificationAdd.jsx